import React from "react";

/**
 * Обёртка поля: подпись, рамка, подсказка/ошибка.
 * children — сам <input>/<select>. extra — что-то под рамкой (например, индикатор пароля).
 */
export default function Field({
  label,
  opt,
  icon,
  error,
  hint,
  hintTone,
  full,
  select,
  extra,
  children,
}) {
  return (
    <label className={`fx-field${full ? " full" : ""}${error ? " err" : ""}`}>
      <span className="lbl">
        {label}
        {opt ? <span className="opt">{opt}</span> : null}
      </span>
      <span className={`inp${select ? " sel" : ""}`}>
        {icon}
        {children}
      </span>
      {extra}
      {error || hint ? (
        <span className={`hint${error ? " err" : hintTone ? ` ${hintTone}` : ""}`}>
          {error || hint}
        </span>
      ) : null}
    </label>
  );
}
